module.exports = __webpack_public_path__ + "static/media/gaizao-haimenrenminyiyuan.c2a284e5.jpg";